import React from 'react'
import { Helmet } from 'react-helmet-async'
import { UrlEndpointFunctionTitleLayout } from '../../layouts/Settings'

const UrlEndpointFunctionTitlePage = (): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>URL Endpoint Functions Title</title>
      <meta name="description" content="URL Endpoint Function Title page" />
    </Helmet>
    <UrlEndpointFunctionTitleLayout />
  </React.Fragment>
)

export default UrlEndpointFunctionTitlePage